import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// Styles
import { Wrapper } from './Button.styles';

const Button = ({ text, callback, to, variant = 'primary', disabled }) =>
  to ? (
    <Wrapper as={Link} to={to} $variant={variant}>
      {text}
    </Wrapper>
  ) : (
    <Wrapper type='button' onClick={callback} $variant={variant} disabled={disabled}>
      {text}
    </Wrapper>
  );

Button.propTypes = {
  text: PropTypes.string,
  callback: PropTypes.func,
  to: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'ghost', 'light']),
  disabled: PropTypes.bool
};

export default Button;
